exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.outside-class[data-v-3263959a] {\n    border-radius: 50px;\n    background-color: #f8f8f8;\n}\n", ""]);

// exports
